const SW_REG_DONE_FLAG = Symbol.for('SW_REG_DONE')

export default function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return
  if (window[SW_REG_DONE_FLAG]) return
  window[SW_REG_DONE_FLAG] = true

  navigator.serviceWorker.register('/service-worker.js', { scope: '/' }).then(reg => {
    // Check for updates whenever the user returns to the tab
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') reg.update()
    })

    // Fallback periodic check
    setInterval(() => reg.update(), 60 * 60 * 1000)

    // If a new worker is installing, ask it to activate ASAP
    reg.addEventListener('updatefound', () => {
      const nw = reg.installing
      if (!nw) return
      nw.addEventListener('statechange', () => {
        if (nw.state === 'installed' && navigator.serviceWorker.controller) {
          // Tell the waiting worker to activate immediately
          nw.postMessage({ type: 'SKIP_WAITING' })
        }
      })
    })

    // If one is already waiting (e.g., after returning to the app)
    if (reg.waiting) {
      reg.waiting.postMessage({ type: 'SKIP_WAITING' })
    }

    // Reload once per page instance after a new SW takes control.
    let refreshing = false
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return
      refreshing = true

      window.location.reload()
    })
  })
}
